/* ROG configurateur : « Trouver ma configuration » (23/09/2026).
   Quelques questions, deux propositions, puis la fiche se règle seule : variantes Shopify
   (sélecteurs natifs) et options Globo (clic sur les boutons radio d'origine).
   La logique lit les SKU et les « original-value » de Globo, jamais les libellés traduits. */
(function () {
  'use strict';
  if (window.ROGConfigurateur) return;
  window.ROGConfigurateur = true;

  /* Mise en service progressive : tant que VERROU vaut true, le bouton n'apparaît qu'avec
     ?rogconf=1 (mémorisé sur l'appareil ; ?rogconf=0 l'efface). */
  var VERROU = false;
  function autorise() {
    var q = location.search;
    try {
      if (/[?&]rogconf=1\b/.test(q)) localStorage.setItem('rogc', '1');
      if (/[?&]rogconf=0\b/.test(q)) localStorage.removeItem('rogc');
      return !VERROU || localStorage.getItem('rogc') === '1';
    } catch (e) { return !VERROU || /[?&]rogconf=1\b/.test(q); }
  }

  /* Netteté des vignettes Globo : l'app les demande en 90 px de large, puis la fiche les agrandit
     pour remplir le carré ; sur écran Retina elles sortent floues. On redemande la même image en 400 px. */
  function vignettesNettes() {
    Array.prototype.forEach.call(document.querySelectorAll('.gpo-ov-item img'), function (img) {
      var src = img.getAttribute('src') || '';
      var m = src.match(/[?&]width=(\d+)/);
      if (!m || parseInt(m[1], 10) >= 400) return;
      img.setAttribute('src', src.replace(/([?&]width=)\d+/, '$1400'));
      if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
    });
  }
  var attenteNette = false;
  new MutationObserver(function () {
    if (attenteNette) return;
    attenteNette = true;
    requestAnimationFrame(function () { attenteNette = false; vignettesNettes(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  vignettesNettes();

  var noeudDonnees = document.getElementById('rogc-donnees');
  var entree = document.getElementById('rogc-entree');
  if (!noeudDonnees || !entree) return;
  var D;
  try { D = JSON.parse(noeudDonnees.textContent); } catch (e) { return; }

  var REDUIT = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.23, 1, .32, 1)';
  var T = {};
  function t(k, v) {
    var s = T[k] != null ? T[k] : k;
    if (v) for (var x in v) s = s.split('{' + x + '}').join(v[x]);
    return s;
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function attendre(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* ---------- Monnaie ---------- */
  var SC = (window.Shopify && window.Shopify.currency) || {};
  var DEVISE = SC.active || 'EUR';
  var TAUX = parseFloat(SC.rate || '1') || 1;
  var LANGUE = document.documentElement.lang || 'fr';
  var nf;
  try { nf = new Intl.NumberFormat(LANGUE, { style: 'currency', currency: DEVISE, maximumFractionDigits: 0, minimumFractionDigits: 0 }); }
  catch (e) { nf = { format: function (n) { return Math.round(n) + ' ' + DEVISE; }, formatToParts: null }; }
  function argent(n) { return nf.format(Math.round(n)); }
  function symbole() {
    try { var p = nf.formatToParts(0).filter(function (x) { return x.type === 'currency'; })[0]; return p ? p.value : DEVISE; }
    catch (e) { return DEVISE; }
  }
  var MPERF = 250 * TAUX; /* embouts M Performance : +250 € dans Globo */

  /* ---------- Produit ---------- */
  function lireSku(s) {
    s = String(s || '').toUpperCase();
    var re = /-(INOX|TITANE|TI)(?=-|$)/g, m, der = null;
    while ((m = re.exec(s))) der = { i: m.index, l: m[0].length, v: m[1] };
    var mat = der && der.v !== 'INOX' ? 'ti' : 'inox';
    var queue = der ? s.slice(der.i + der.l) : '';
    var tete = der ? s.slice(0, der.i) : s;
    var lvl = /DECAT/.test(queue) ? 3 : /100/.test(queue) ? 2 : /200/.test(queue) ? 1 : 0;
    var conc = /-ELZ$/.test(tete) ? 'elz' : /-EL$/.test(tete) ? 'el' : 'std';
    return { mat: mat, lvl: lvl, conc: conc };
  }
  var VARS = D.variantes.map(function (v) {
    var p = lireSku(v.sku);
    return { id: v.id, options: v.options, dispo: v.dispo, prix: v.prix / 100, mat: p.mat, lvl: p.lvl, conc: p.conc };
  });
  var AVANT = VARS.some(function (v) { return v.lvl > 0; });
  var CONCEPTION = VARS.some(function (v) { return v.conc !== 'std'; });
  var PIECE = { turbo: 'downpipe', atmo: 'collecteur', compresseur: 'collecteur', mixte: 'avant' }[D.sur] || 'downpipe';

  /* ---------- Globo ---------- */
  function gpoInputs(part) {
    part = part.toLowerCase();
    return Array.prototype.filter.call(document.querySelectorAll('.gpo-ov-item input[type="radio"]'), function (i) {
      return (i.getAttribute('data-field-name') || i.name || '').toLowerCase().indexOf(part) !== -1;
    });
  }
  function ov(i) { return i.getAttribute('original-value') || i.value; }
  function gpoImages(part) {
    var o = {};
    gpoInputs(part).forEach(function (i) {
      var img = i.closest('.gpo-ov-item') && i.closest('.gpo-ov-item').querySelector('img');
      if (img && !o[ov(i)]) o[ov(i)] = (img.currentSrc || img.src || '').replace(/width=\d+/, 'width=300');
    });
    return o;
  }
  var EMB_ROG = [['carbone', 'Carbone', 'e_carbone'], ['chrome', 'Chrome', 'e_chrome'], ['noir', 'Noir brillant', 'e_noir'], ['bleui', 'Titane bleui', 'e_bleui']];
  var EMB_MP = [['forge', 'Carbone - Forgé', 'mp_forge'], ['noir', 'Carbone - Noir', 'mp_noir'], ['titane', 'Carbone - Titane', 'mp_titane'], ['chrome', 'Carbone - Chrome', 'mp_chrome']];
  var COUL = [['brosse', 'Brossé', 'ct_brosse'], ['or', 'Or', 'ct_or'], ['violet', 'Violet', 'ct_violet']];
  var G = { rog: false, mp: false, img: {} };
  function lireGlobo() {
    G.rog = gpoInputs('embouts rog').length > 0;
    G.mp = gpoInputs('embouts m perf').length > 0;
    G.clapets = gpoInputs('clapets').length > 0;
    G.img = { rog: gpoImages('embouts rog'), mp: gpoImages('embouts m perf'), clap: gpoImages('clapets'), coul: gpoImages('couleur titane'), reso: gpoImages('caractère du son') };
    /* « Caractère du son » : seulement sur les fiches où le résonateur se loge (jeux Globo « + résonateur »).
       Les libellés sont repérés par leur valeur française d'origine, pas par leur traduction. */
    G.resoVals = { pur: null, rond: null };
    gpoInputs('caractère du son').forEach(function (i) { if (/r[ée]sonateur/i.test(ov(i))) G.resoVals.rond = ov(i); else G.resoVals.pur = ov(i); });
    G.reso = !!(G.resoVals.pur && G.resoVals.rond);
  }

  /* ---------- Questions ---------- */
  function questions(a) {
    var q = [];
    q.push({ id: 'usage', titre: t('q_usage_t'), aide: t(AVANT ? 'q_usage_h' : 'q_usage_h_ligne'), choix: [
      ['quotidien', t('u_quotidien'), t('u_quotidien_d')], ['weekend', t('u_weekend'), t('u_weekend_d')],
      ['circuit', t('u_circuit'), t('u_circuit_d')], ['compet', t('u_compet'), t('u_compet_d')]] });
    if (AVANT) {
      q.push({ id: 'son', type: 'son', titre: t('q_son_t'), aide: t('q_son_h'), choix: [
        ['7', t('s7'), t('s7_d')], ['8', t('s8'), t('s8_d')], ['9', t('s9'), t('s9_d')], ['10', t('s10'), t('s10_d')]] });
      q.push({ id: 'cat', titre: t('q_cat_t'), aide: t('q_cat_h'), choix: [
        ['strict', t('c_strict'), t('c_strict_d')], ['souple', t('c_souple'), t('c_souple_d')], ['libre', t('c_libre'), t('c_libre_d')]] });
      q.push({ id: 'reprog', titre: t('q_reprog_t'), aide: t({ turbo: 'q_reprog_h_turbo', atmo: 'q_reprog_h_atmo', compresseur: 'q_reprog_h_comp', mixte: 'q_reprog_h_mixte' }[D.sur] || 'q_reprog_h_turbo'), choix: [
        ['oui', t('r_oui')], ['prevu', t('r_prevu')], ['non', t('r_non')]] });
    }
    if (CONCEPTION) q.push({ id: 'conception', titre: t('q_conc_t'), aide: t('q_conc_h'), choix: [
      ['std', t('k_std'), t('k_std_d')], ['el', t('k_el'), t('k_el_d')], ['elz', t('k_elz'), t('k_elz_d')]] });
    q.push({ id: 'timbre', titre: t('q_timbre_t'), aide: t('q_timbre_h'), choix: [
      ['grave', t('t_grave'), t('t_grave_d')], ['aigu', t('t_aigu'), t('t_aigu_d')], ['egal', t('t_egal'), t('t_egal_d')]] });
    if (G.reso) q.push({ id: 'reso', titre: t('q_reso_t'), aide: t('q_reso_h'), choix: [
      ['pur', t('re_non'), t('re_non_d'), G.img.reso[G.resoVals.pur]], ['rond', t('re_oui'), t('re_oui_d'), G.img.reso[G.resoVals.rond]]] });
    if (G.clapets) q.push({ id: 'clapets', titre: t('q_clap_t'), aide: t('q_clap_h'), choix: [
      ['rog', t('cl_rog'), t('cl_rog_d'), G.img.clap.ROG], ['origine', t('cl_origine'), t('cl_origine_d'), G.img.clap.Origine]] });
    if (G.rog || G.mp) q.push({ id: 'embouts', type: 'tuiles', titre: t('q_emb_t'), aide: t(G.mp ? 'q_emb_h_bmw' : 'q_emb_h_rog') });
    q.push({ id: 'budget', type: 'budget', titre: t('q_budget_t'), aide: t('q_budget_h') });
    return q;
  }

  /* ---------- Recommandation ---------- */
  function plafond(a) { return a.cat === 'strict' ? 1 : a.cat === 'souple' ? 2 : 3; }
  function ideal(a) {
    var circuit = a.usage === 'circuit' || a.usage === 'compet';
    var mat = a.timbre === 'aigu' ? 'ti' : a.timbre === 'grave' ? 'inox' : (circuit ? 'ti' : 'inox');
    var lvl = 0;
    if (AVANT) {
      var n = (parseInt(a.son || '7', 10)) - 7;
      var puissance = a.reprog === 'oui' || a.reprog === 'prevu';
      if (puissance && a.cat && a.cat !== 'strict' && circuit) n = Math.max(n, 2);
      if (puissance) n = Math.max(n, 1);
      lvl = Math.min(n, plafond(a));
    }
    return { mat: mat, lvl: lvl, conc: CONCEPTION ? (a.conception || 'std') : 'std', clapets: a.clapets || 'rog', emb: a.embouts || 'origine', couleur: 'brosse', reso: a.reso || 'pur' };
  }
  function variante(c) {
    return VARS.filter(function (v) {
      return v.mat === c.mat && (!AVANT || v.lvl === c.lvl) && (!CONCEPTION || v.conc === c.conc);
    })[0] || null;
  }
  function prix(c) { var v = variante(c); return v ? v.prix + (c.emb.indexOf('mp:') === 0 ? MPERF : 0) : Infinity; }
  function idx(k) { return { std: 0, el: 1, elz: 2 }[k] || 0; }
  function ecart(c, i) {
    var d = 0;
    if (c.mat !== i.mat) d += 2;
    if (AVANT) d += Math.abs(c.lvl - i.lvl) * 1.5;
    if (CONCEPTION) d += Math.abs(idx(c.conc) - idx(i.conc));
    if (c.emb !== i.emb) d += 0.8;
    return d;
  }
  function candidats(a, i) {
    var dispo = VARS.some(function (v) { return v.dispo; });
    var embs = [i.emb];
    if (i.emb.indexOf('mp:') === 0) embs.push(G.rog ? 'rog:carbone' : 'origine');
    var out = [];
    VARS.forEach(function (v) {
      if (dispo && !v.dispo) return;
      if (AVANT && v.lvl > plafond(a)) return;
      embs.forEach(function (e) {
        out.push({ mat: v.mat, lvl: v.lvl, conc: v.conc, clapets: i.clapets, emb: e, couleur: i.couleur, reso: i.reso });
      });
    });
    return out;
  }
  function recommander(a) {
    var I = ideal(a), cs = candidats(a, I);
    var A = variante(I) && cs.some(function (c) { return c.mat === I.mat && c.lvl === I.lvl && c.conc === I.conc; }) ? I
      : cs.slice().sort(function (x, y) { return ecart(x, I) - ecart(y, I); })[0];
    var pa = prix(A), B, mode;
    if (a.budget && pa > a.budget) {
      mode = 'budget';
      var tient = cs.filter(function (c) { return prix(c) <= a.budget; });
      if (tient.length) B = tient.sort(function (x, y) { return ecart(x, A) - ecart(y, A) || prix(y) - prix(x); })[0];
      else mode = 'accessible', B = cs.slice().sort(function (x, y) { return prix(x) - prix(y) || ecart(x, A) - ecart(y, A); })[0];
    } else {
      mode = a.budget ? 'alt' : 'libre';
      B = cs.filter(function (c) { return c.mat !== A.mat || c.lvl !== A.lvl || c.conc !== A.conc; })
        .sort(function (x, y) { return ecart(x, A) - ecart(y, A) || prix(x) - prix(y); })[0];
    }
    A = Object.assign({}, A); B = B ? Object.assign({}, B) : null;
    var pareil = function (x, y) { return x && y && x.mat === y.mat && x.lvl === y.lvl && x.conc === y.conc && x.emb === y.emb; };
    var seule = !B || pareil(A, B);
    /* Troisième proposition : la plus adaptée, à l'identique mais en inox (même pièce avant, même
       conception, même volume). Seulement si elle est en titane et que l'inox n'est pas déjà proposé. */
    var C = null;
    if (A.mat === 'ti') {
      var ci = Object.assign({}, A, { mat: 'inox', couleur: 'brosse' });
      if (cs.some(function (x) { return x.mat === 'inox' && x.lvl === ci.lvl && x.conc === ci.conc; }) && !pareil(ci, seule ? null : B)) C = ci;
    }
    return { A: A, B: seule ? null : B, C: C, mode: seule && (mode === 'budget' || mode === 'accessible') ? 'seule' : mode, budget: a.budget };
  }

  /* ---------- Textes des propositions ---------- */
  function nomNiveau(l) { return t('lvl' + l + '_' + PIECE); }
  function nomConc(k) { return { std: 'Standard', el: 'Equal Length', elz: 'Equal Length + Z-pipe' }[k]; }
  function titreConfig(c) {
    var p = [t(c.mat === 'ti' ? 'm_ti' : 'm_inox')];
    if (AVANT) p.push(nomNiveau(c.lvl));
    if (CONCEPTION) p.push(nomConc(c.conc));
    return p.join(' · ');
  }
  function niveau10(c) { return AVANT ? 7 + c.lvl : 7; }
  function decibels(c) {
    var d = (AVANT ? [0, 2, 4, 6][c.lvl] : 0) + (c.mat === 'ti' ? 1 : 0) + (c.conc === 'elz' ? 1 : 0);
    var f = 84 + d * 0.35;
    /* Résonateur : la ligne reste forte, la voix s'arrondit à peine (- 1 dB fermés, - 2 dB ouverts). */
    var r = G.reso && c.reso === 'rond';
    return [Math.round(f - (r ? 1 : 0)), Math.round(f + 13 + d * 0.6 - (r ? 2 : 0))];
  }
  function nomEmbout(e) {
    var k = e.split(':'), l = k[0] === 'mp' ? EMB_MP : EMB_ROG;
    var x = l.filter(function (y) { return y[0] === k[1]; })[0];
    return x ? t(x[2]) : '';
  }
  function raisons(a, c) {
    var r = [], us = t('us_' + (a.usage || 'weekend'));
    if (c.mat === 'ti') r.push(a.timbre === 'aigu' ? t('rz_ti_aigu') : t('rz_ti_usage', { usage: us }));
    else r.push(a.timbre === 'grave' ? t('rz_inox_grave') : t('rz_inox_usage', { usage: us }));
    if (AVANT) {
      var puissance = a.reprog === 'oui' || a.reprog === 'prevu', lvl = nomNiveau(c.lvl);
      if (c.lvl === 0) r.push(t(puissance ? 'rz_p0_budget' : 'rz_p0_inutile', { lvl: lvl }));
      else if (c.lvl === 1) r.push(t(a.cat === 'strict' ? 'rz_p1_strict' : 'rz_p1', { lvl: lvl }));
      else if (c.lvl === 2) r.push(t(parseInt(a.son, 10) > 9 ? 'rz_p2_cap' : 'rz_p2', { lvl: lvl }));
      else r.push(t('rz_p3', { lvl: lvl }));
      if (puissance && c.lvl > 0) r.push(t('rz_power'));
    }
    if (CONCEPTION) r.push(t('rz_' + c.conc));
    if (G.reso) r.push(t(c.reso === 'rond' ? 'rz_reso_oui' : 'rz_reso_non'));
    if (G.clapets) r.push(t(c.clapets === 'rog' ? 'rz_clap_rog' : 'rz_clap_origine'));
    if (G.rog || G.mp) {
      if (c.emb === 'origine') r.push(t('rz_emb_origine'));
      else r.push(t(c.emb.indexOf('mp:') === 0 ? 'rz_emb_mp' : 'rz_emb_rog', { x: nomEmbout(c.emb).toLowerCase() }));
    }
    return r;
  }
  function changements(A, B) {
    var r = [];
    if (A.mat !== B.mat) r.push(t(B.mat === 'inox' ? 'ch_inox' : 'ch_ti'));
    if (AVANT && A.lvl !== B.lvl) r.push(t(B.lvl < A.lvl ? 'ch_lvl_moins' : 'ch_lvl_plus', { a: nomNiveau(A.lvl).toLowerCase(), b: nomNiveau(B.lvl), na: niveau10(A), nb: niveau10(B) }));
    if (CONCEPTION && A.conc !== B.conc) r.push(t('ch_conc', { a: nomConc(A.conc), b: nomConc(B.conc) }));
    if (A.emb !== B.emb && A.emb.indexOf('mp:') === 0) r.push(t('ch_emb'));
    return r;
  }

  /* ---------- Icônes ---------- */
  var I_X = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 4l8 8M12 4l-8 8"/></svg>';
  var I_RETOUR = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10 3.5L5.5 8l4.5 4.5"/></svg>';
  var I_COCHE = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 6.2l2.3 2.3 4.7-5"/></svg>';
  var I_INFO = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="8" cy="8" r="6.5"/><path d="M8 7.2v4M8 4.9v.1"/></svg>';
  var I_OK = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="8" r="6.5"/><path d="M5.2 8.2l1.9 1.9 3.8-4.1"/></svg>';

  /* ---------- Fenêtre ---------- */
  var E = {}, etat = { a: {}, pas: 0, ouvert: false, vue: 'q' };
  function construire() {
    var f = document.createElement('div');
    f.className = 'rogc-root rogc-fenetre';
    f.hidden = true;
    f.setAttribute('role', 'dialog');
    f.setAttribute('aria-modal', 'true');
    f.setAttribute('aria-label', t('cta_titre'));
    f.innerHTML = '<div class="rogc-voile" data-rogc-fermer></div>' +
      '<div class="rogc-boite"><div class="rogc-poignee" aria-hidden="true"></div>' +
      '<div class="rogc-tete"><div class="rogc-tete__ligne"><div class="rogc-marque">' +
      '<button type="button" class="rogc-rond" data-rogc-retour aria-label="' + esc(t('retour')) + '">' + I_RETOUR + '</button>' +
      '<span class="rogc-marque__logo">ROG</span><span class="rogc-marque__sep"></span><span class="rogc-etape" aria-live="polite"></span></div>' +
      '<button type="button" class="rogc-rond" data-rogc-fermer aria-label="' + esc(t('fermer')) + '">' + I_X + '</button></div>' +
      '<div class="rogc-progres"><i></i></div></div>' +
      '<div class="rogc-corps"><div class="rogc-scene"></div></div><div class="rogc-pied" hidden></div></div>';
    document.body.appendChild(f);
    E.f = f; E.voile = f.querySelector('.rogc-voile'); E.boite = f.querySelector('.rogc-boite');
    E.etape = f.querySelector('.rogc-etape'); E.barre = f.querySelector('.rogc-progres i');
    E.corps = f.querySelector('.rogc-corps'); E.scene = f.querySelector('.rogc-scene');
    E.pied = f.querySelector('.rogc-pied'); E.retour = f.querySelector('[data-rogc-retour]');
    f.addEventListener('click', function (ev) { if (ev.target.closest('[data-rogc-fermer]')) fermer(); });
    E.retour.addEventListener('click', function () { if (etat.vue === 'res') { etat.vue = 'q'; etat.pas = questions(etat.a).length - 1; rendre(-1); } else if (etat.pas > 0) { etat.pas--; rendre(-1); } });
    f.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') { ev.preventDefault(); fermer(); }
      if (ev.key === 'Tab') {
        var el = E.boite.querySelectorAll('button:not([disabled]), input, [tabindex="0"]');
        if (!el.length) return;
        var p = el[0], d = el[el.length - 1];
        if (ev.shiftKey && document.activeElement === p) { ev.preventDefault(); d.focus(); }
        else if (!ev.shiftKey && document.activeElement === d) { ev.preventDefault(); p.focus(); }
      }
    });
    glisser();
  }
  /* Sur mobile, le panneau se ferme en le tirant vers le bas depuis l'en-tête. */
  function glisser() {
    var y0 = null, dy = 0, zone = E.boite.querySelector('.rogc-tete');
    function mobile() { return window.matchMedia('(max-width: 749px)').matches; }
    E.boite.querySelector('.rogc-poignee').style.touchAction = 'none';
    zone.style.touchAction = 'none';
    [zone, E.boite.querySelector('.rogc-poignee')].forEach(function (z) {
      z.addEventListener('pointerdown', function (ev) { if (!mobile() || ev.target.closest('button')) return; y0 = ev.clientY; dy = 0; E.boite.style.transition = 'none'; z.setPointerCapture(ev.pointerId); });
      z.addEventListener('pointermove', function (ev) { if (y0 === null) return; dy = Math.max(0, ev.clientY - y0); E.boite.style.transform = 'translateY(' + dy + 'px)'; });
      z.addEventListener('pointerup', function () {
        if (y0 === null) return; y0 = null; E.boite.style.transition = '';
        if (dy > 110) fermer(); else E.boite.animate([{ transform: 'translateY(' + dy + 'px)' }, { transform: 'none' }], { duration: 320, easing: EASE }).onfinish = function () { E.boite.style.transform = ''; };
        if (dy <= 110) E.boite.style.transform = '';
      });
    });
  }
  function ouvrir() {
    if (!E.f) construire();
    lireGlobo();
    [G.img.rog, G.img.mp, G.img.clap, G.img.coul, G.img.reso, { i: D.image }].forEach(function (o) { for (var k in o) if (o[k]) { var im = new Image(); im.src = o[k]; } });
    etat = { a: {}, pas: 0, ouvert: true, vue: 'q' };
    E.boite.classList.remove('est-large');
    E.f.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    rendre(0);
    if (!REDUIT) {
      var mob = window.matchMedia('(max-width: 749px)').matches;
      E.voile.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 320, easing: EASE });
      E.boite.animate(mob ? [{ transform: 'translateY(100%)' }, { transform: 'none' }] : [{ opacity: 0, transform: 'translateY(18px) scale(.975)' }, { opacity: 1, transform: 'none' }], { duration: mob ? 520 : 480, easing: EASE });
    }
  }
  function fermer() {
    if (!etat.ouvert) return;
    etat.ouvert = false;
    var fin = function () { E.f.hidden = true; E.boite.style.transform = ''; document.documentElement.style.overflow = ''; var b = document.getElementById('rogc-ouvrir'); if (b) b.focus({ preventScroll: true }); };
    if (REDUIT) return fin();
    var mob = window.matchMedia('(max-width: 749px)').matches;
    E.voile.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 260, easing: EASE, fill: 'forwards' });
    E.boite.animate(mob ? [{ transform: getComputedStyle(E.boite).transform === 'none' ? 'none' : getComputedStyle(E.boite).transform }, { transform: 'translateY(100%)' }] : [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(12px) scale(.98)' }], { duration: 280, easing: 'cubic-bezier(.4, 0, 1, 1)', fill: 'forwards' }).onfinish = function () {
      E.voile.getAnimations().forEach(function (x) { x.cancel(); }); E.boite.getAnimations().forEach(function (x) { x.cancel(); }); fin();
    };
  }

  /* Changement de scène : l'ancienne glisse et s'efface, la nouvelle arrive du côté opposé,
     puis ses éléments entrent l'un après l'autre. */
  var enCours = null;
  function transition(html, sens, apres) {
    var s = E.scene;
    var poser = function () {
      s.innerHTML = html;
      E.corps.scrollTop = 0;
      if (apres) apres(s);
      if (REDUIT) return;
      s.animate([{ opacity: 0, transform: 'translateX(' + (sens >= 0 ? 28 : -28) + 'px)' }, { opacity: 1, transform: 'none' }], { duration: 420, easing: EASE });
      Array.prototype.forEach.call(s.querySelectorAll('[data-rogc-e]'), function (el, i) {
        el.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: 480, delay: 60 + i * 45, easing: EASE, fill: 'backwards' });
      });
    };
    if (REDUIT || !s.children.length) return poser();
    if (enCours) enCours.cancel();
    enCours = s.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateX(' + (sens >= 0 ? -22 : 22) + 'px)' }], { duration: 170, easing: 'cubic-bezier(.4, 0, 1, 1)', fill: 'forwards' });
    var fait = false, suite = function () { if (fait) return; fait = true; if (enCours) { enCours.cancel(); enCours = null; } poser(); };
    enCours.onfinish = suite;
    setTimeout(suite, 200);
  }

  function rendre(sens) {
    var qs = questions(etat.a);
    if (etat.pas > qs.length - 1) etat.pas = qs.length - 1;
    var q = qs[etat.pas];
    E.boite.classList.remove('est-large', 'a-trois');
    E.retour.disabled = etat.pas === 0;
    E.etape.textContent = t('etape', { n: etat.pas + 1, t: qs.length });
    E.barre.style.width = Math.round((etat.pas + 0.35) / (qs.length + 0.4) * 100) + '%';
    var h = '<h2 class="rogc-q__t" data-rogc-e>' + esc(q.titre) + '</h2><p class="rogc-q__h" data-rogc-e>' + esc(q.aide) + '</p>';
    if (q.type === 'budget') h += vueBudget();
    else if (q.type === 'tuiles') h += vueEmbouts();
    else h += '<div class="rogc-choix-liste">' + q.choix.map(function (c) { return choixHtml(q, c); }).join('') + '</div>';
    E.pied.hidden = q.type === 'budget';
    E.pied.innerHTML = q.type === 'budget' ? '' : '<span class="rogc-indice">' + esc(t('un_choix')) + '</span>';
    transition(h, sens, function (s) { brancher(s, q); });
  }
  function choixHtml(q, c) {
    var sel = etat.a[q.id] === c[0];
    var barres = '';
    if (q.type === 'son') {
      var n = parseInt(c[0], 10);
      for (var i = 1; i <= 10; i++) barres += '<i class="' + (i <= n ? 'on' + (i >= 9 ? ' fort' : '') : '') + '" style="height:' + (30 + i * 7) + '%"></i>';
      barres = '<span class="rogc-niveau" aria-hidden="true">' + barres + '</span>';
    }
    return '<button type="button" class="rogc-choix' + (c[3] ? ' a-image' : '') + (q.type === 'son' ? ' rogc-choix-son' : '') + '" data-rogc-e data-v="' + esc(c[0]) + '" aria-pressed="' + sel + '">' +
      (c[3] ? '<img class="rogc-choix__img" src="' + esc(c[3]) + '" alt="">' : '') +
      '<span><span class="rogc-choix__t">' + esc(c[1]) + '</span>' + (c[2] ? '<span class="rogc-choix__d">' + esc(c[2]) + '</span>' : '') + '</span>' +
      barres + '<span class="rogc-coche" aria-hidden="true">' + I_COCHE + '</span></button>';
  }
  function tuile(v, titre, desc, img, large) {
    return '<button type="button" class="rogc-tuile' + (large ? ' rogc-tuile--large' : '') + '" data-rogc-e data-v="' + esc(v) + '" aria-pressed="' + (etat.a.embouts === v) + '">' +
      (img ? '<img src="' + esc(img) + '" alt="">' : '') +
      '<span><span class="rogc-tuile__t">' + esc(titre) + '</span>' + (desc ? '<br><span class="rogc-tuile__d">' + esc(desc) + '</span>' : '') + '</span></button>';
  }
  function vueEmbouts() {
    var h = '';
    if (G.rog) {
      h += '<p class="rogc-groupe" data-rogc-e>' + esc(t('emb_rog_grp')) + '</p><div class="rogc-tuiles">';
      EMB_ROG.forEach(function (e) { if (G.img.rog[e[1]] !== undefined || true) h += tuile('rog:' + e[0], t(e[2]), t('offerts'), G.img.rog[e[1]]); });
      h += '</div>';
    }
    if (G.mp) {
      h += '<p class="rogc-groupe" data-rogc-e>' + esc(t('emb_mp_grp')) + '</p><div class="rogc-tuiles">';
      EMB_MP.forEach(function (e) { h += tuile('mp:' + e[0], t(e[2]), '+ ' + argent(MPERF), G.img.mp[e[1]]); });
      h += '</div>';
    }
    h += '<p class="rogc-groupe" data-rogc-e>' + esc(t('emb_ou')) + '</p><div class="rogc-tuiles">' + tuile('origine', t('emb_origine'), '', G.img.rog['Sans embout'] || G.img.mp['Sans embout'], true) + '</div>';
    return h;
  }
  function bornes() {
    var ps = VARS.map(function (v) { return v.prix; });
    return [Math.min.apply(null, ps), Math.max.apply(null, ps) + (G.mp ? MPERF : 0)];
  }
  function vueBudget() {
    var b = bornes();
    return '<label class="rogc-budget" data-rogc-e for="rogc-budget"><input id="rogc-budget" inputmode="numeric" autocomplete="off" placeholder="' + esc(t('budget_ph')) + '" value="' + (etat.a.budget ? esc(new Intl.NumberFormat(LANGUE).format(etat.a.budget)) : '') + '"><span class="rogc-budget__devise">' + esc(symbole()) + '</span></label>' +
      '<p class="rogc-plage" data-rogc-e>' + esc(t('budget_plage', { min: argent(b[0]), max: argent(b[1]) })) + '</p>' +
      '<div class="rogc-rangee" data-rogc-e><button type="button" class="rogc-lien" data-rogc-sans>' + esc(t('budget_aucun')) + '</button>' +
      '<button type="button" class="rogc-bouton rogc-bouton--noir" data-rogc-voir disabled>' + esc(t('voir')) + '</button></div>';
  }
  function brancher(s, q) {
    if (q.type === 'budget') {
      var inp = s.querySelector('input'), voir = s.querySelector('[data-rogc-voir]');
      var val = function () { var n = parseInt(inp.value.replace(/[^\d]/g, ''), 10); return isNaN(n) || n <= 0 ? null : n; };
      var maj = function () { var n = val(); voir.disabled = !n; if (n) { var f = new Intl.NumberFormat(LANGUE).format(n); if (inp.value !== f) inp.value = f; } };
      inp.addEventListener('input', maj); maj();
      inp.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' && val()) voir.click(); });
      voir.addEventListener('click', function () { etat.a.budget = val(); composer(); });
      s.querySelector('[data-rogc-sans]').addEventListener('click', function () { etat.a.budget = null; composer(); });
      setTimeout(function () { try { inp.focus({ preventScroll: true }); } catch (e) {} }, REDUIT ? 0 : 380);
      return;
    }
    Array.prototype.forEach.call(s.querySelectorAll('[data-v]'), function (b) {
      b.addEventListener('click', function () {
        etat.a[q.id] = b.getAttribute('data-v');
        Array.prototype.forEach.call(s.querySelectorAll('[data-v]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        setTimeout(function () { etat.pas++; rendre(1); }, REDUIT ? 60 : 280);
      });
    });
    var premier = s.querySelector('[aria-pressed="true"]') || s.querySelector('[data-v]');
    if (premier) setTimeout(function () { try { premier.focus({ preventScroll: true }); } catch (e) {} }, REDUIT ? 0 : 420);
  }

  /* Un temps de composition, puis les propositions. */
  function composer() {
    E.pied.hidden = true;
    E.etape.textContent = '';
    E.barre.style.width = '100%';
    var bars = ''; for (var i = 0; i < 9; i++) bars += '<i style="animation-delay:' + (i * 90) + 'ms"></i>';
    transition('<div class="rogc-compo"><div class="rogc-compo__barres" aria-hidden="true">' + bars + '</div><p>' + esc(t('res_titre')) + '…</p></div>', 1);
    setTimeout(resultats, REDUIT ? 0 : 1100);
  }
  function carte(c, o) {
    var n = niveau10(c), db = decibels(c), segs = '';
    for (var i = 1; i <= 10; i++) segs += '<i class="' + (i <= n ? 'on' + (i >= 9 ? ' fort' : '') : '') + '" style="animation-delay:' + (200 + i * 55) + 'ms;height:' + (35 + i * 6.5) + '%"></i>';
    var h = '<article class="rogc-carte' + (o.reco ? ' est-reco' : '') + '" data-rogc-e data-cle="' + o.cle + '">' +
      '<div class="rogc-carte__corps"><div class="rogc-carte__tete"><span class="rogc-badge">' + esc(o.badge) + '</span><h3 class="rogc-carte__titre">' + esc(titreConfig(c)) + '</h3>' +
      '<div class="rogc-prix"><b data-rogc-prix="' + prix(c) + '">' + esc(argent(prix(c))) + '</b>' + (o.ecart || '') + '</div></div>' +
      '<div class="rogc-son"><div class="rogc-son__ligne"><span>' + esc(t('volume')) + '</span><b>' + n + '/10</b></div><div class="rogc-son__barres" aria-hidden="true">' + segs + '</div>' +
      '<span class="rogc-son__db">' + esc(t('db', { f: db[0], o: db[1] })) + '</span></div>';
    if (c.mat === 'ti' && Object.keys(G.img.coul).length) {
      h += '<div class="rogc-bloc"><p class="rogc-bloc__t">' + esc(t('couleur_titane')) + '</p><div class="rogc-pastilles">' +
        COUL.map(function (k) { return '<button type="button" class="rogc-pastille" data-coul="' + k[0] + '" aria-pressed="' + (c.couleur === k[0]) + '">' + (G.img.coul[k[1]] ? '<img src="' + esc(G.img.coul[k[1]]) + '" alt="">' : '') + esc(t(k[2])) + '</button>'; }).join('') + '</div></div>';
    }
    h += '<div class="rogc-bloc"><p class="rogc-bloc__t">' + esc(t('pourquoi')) + '</p><ul class="rogc-raisons">' + raisons(etat.a, c).map(function (r) { return '<li>' + I_OK + '<span>' + esc(r) + '</span></li>'; }).join('') + '</ul></div>';
    if (o.change && o.change.length) h += '<div class="rogc-change"><p class="rogc-bloc__t">' + esc(t('change')) + '</p>' + o.change.map(esc).join('<br>') + '</div>';
    if (AVANT && (c.lvl === 2 || c.lvl === 3)) h += '<p class="rogc-mention">' + I_INFO + '<span>' + esc(t(c.lvl === 2 ? 'leg_100' : 'leg_decat')) + '</span></p>';
    h += '</div><div class="rogc-carte__pied"><button type="button" class="rogc-bouton' + (o.reco ? '' : ' rogc-bouton--noir') + '" data-rogc-appliquer="' + o.cle + '">' + esc(t('appliquer')) + '</button></div></article>';
    return h;
  }
  function puce(diff, cle) {
    var cls = diff > 0 ? 'dessus' : 'sous';
    var x = argent(Math.abs(diff));
    if (cle === 'reco') return '<span class="rogc-ecart neutre">' + esc(t('vs_reco', { x: (diff > 0 ? '+ ' : '− ') + x })) + '</span>';
    return '<span class="rogc-ecart ' + cls + '">' + esc(diff > 0 ? t('au_dessus', { x: '+ ' + x }) : t('sous_budget', { x: x })) + '</span>';
  }
  function resultats() {
    var r = recommander(etat.a), A = r.A, B = r.B, C = r.C, intro, titre = t('res_titre');
    var ecartDe = function (c) { return r.budget ? puce(prix(c) - r.budget) : puce(prix(c) - prix(A), 'reco'); };
    var liste = [{ c: A, o: { reco: true, cle: 'A', ecart: r.budget ? puce(prix(A) - r.budget) : '' } }];
    if (C) liste.push({ c: C, o: { cle: 'C', badge: t('badge_inox'), ecart: ecartDe(C), change: [t('ch_inox'), t('ch_meme_son', { n: niveau10(C) })] } });
    if (r.mode === 'seule' || !B) {
      liste[0].o.badge = t('badge_adaptee');
      titre = C ? t('res_titre') : t('res_titre_une');
      intro = r.mode === 'seule' ? t('res_intro_seule') : t('res_intro_libre');
    } else {
      var budget = r.mode === 'budget' || r.mode === 'accessible';
      liste[0].o.badge = t(budget ? 'badge_adaptee' : 'badge_reco');
      intro = t({ budget: 'res_intro_budget', accessible: 'res_intro_accessible', alt: 'res_intro_alt' }[r.mode] || 'res_intro_libre');
      liste.push({ c: B, o: { cle: 'B', badge: t(r.mode === 'accessible' ? 'badge_accessible' : budget ? 'badge_budget' : 'badge_alt'), ecart: ecartDe(B), change: changements(A, B) } });
    }
    if (C && liste.length === 3) {
      titre = t('res_titre_trois');
      intro = t({ budget: 'res_intro_trois_budget', accessible: 'res_intro_trois_accessible' }[r.mode] || 'res_intro_trois_libre');
    } else if (C) intro = t('res_intro_duo_inox');
    var parCle = {}; liste.forEach(function (x) { parCle[x.o.cle] = x.c; });
    etat.vue = 'res';
    E.retour.disabled = false;
    E.etape.textContent = '';
    E.boite.classList.add('est-large');
    E.boite.classList.toggle('a-trois', liste.length === 3);
    E.pied.hidden = false;
    E.pied.innerHTML = '<button type="button" class="rogc-lien" data-rogc-modif>' + esc(t('modifier')) + '</button><button type="button" class="rogc-lien" data-rogc-fermer>' + esc(t('manuel')) + '</button>';
    E.pied.querySelector('[data-rogc-modif]').addEventListener('click', function () { etat.vue = 'q'; etat.pas = 0; E.boite.classList.remove('a-trois'); rendre(-1); });
    var h = '<p class="rogc-res__sur" data-rogc-e>' + esc(t('res_sur')) + '</p><h2 class="rogc-q__t" data-rogc-e>' + esc(titre) + '</h2><p class="rogc-res__intro" data-rogc-e>' + esc(intro) + '</p>' +
      '<div class="rogc-cartes" data-n="' + liste.length + '">' + liste.map(function (x) { return carte(x.c, x.o); }).join('') + '</div>';
    transition(h, 1, function (s) {
      compter(s);
      Array.prototype.forEach.call(s.querySelectorAll('[data-coul]'), function (b) {
        b.addEventListener('click', function () {
          var art = b.closest('[data-cle]'), c = parCle[art.getAttribute('data-cle')];
          c.couleur = b.getAttribute('data-coul');
          Array.prototype.forEach.call(art.querySelectorAll('[data-coul]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        });
      });
      Array.prototype.forEach.call(s.querySelectorAll('[data-rogc-appliquer]'), function (b) {
        b.addEventListener('click', function () { appliquer(parCle[b.getAttribute('data-rogc-appliquer')]); });
      });
    });
  }
  /* Les prix montent jusqu'à leur valeur. */
  function compter(s) {
    if (REDUIT) return;
    Array.prototype.forEach.call(s.querySelectorAll('[data-rogc-prix]'), function (el, k) {
      var fin = parseFloat(el.getAttribute('data-rogc-prix')), debut = fin * 0.86, t0 = null, d = 900;
      function pas(ts) {
        if (t0 === null) t0 = ts + 250 + k * 120;
        var p = Math.min(1, Math.max(0, (ts - t0) / d)), e = 1 - Math.pow(1 - p, 4);
        el.textContent = argent(debut + (fin - debut) * e);
        if (p < 1) requestAnimationFrame(pas);
      }
      requestAnimationFrame(pas);
    });
  }

  /* ---------- Application sur la fiche ---------- */
  function choisirGpo(part, valeur, visible) {
    return new Promise(function (ok) {
      var n = 0;
      (function essai() {
        var i = gpoInputs(part).filter(function (x) { return ov(x) === valeur; })[0];
        var pret = i && (!visible || (i.closest('.gpo-ov-item') && i.closest('.gpo-ov-item').offsetParent !== null));
        if (pret) { if (!i.checked) i.click(); return ok(true); }
        if (++n > 24) return ok(false);
        setTimeout(essai, 150);
      })();
    });
  }
  function appliquer(c) {
    var v = variante(c);
    fermer();
    if (!v) return;
    var selects = document.querySelectorAll('variant-selects select');
    if (selects.length) {
      Array.prototype.forEach.call(selects, function (s, i) {
        var val = v.options[i];
        if (val != null && Array.prototype.some.call(s.options, function (o) { return o.value === val; })) s.value = val;
      });
      selects[selects.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      v.options.forEach(function (val) {
        var r = Array.prototype.filter.call(document.querySelectorAll('variant-radios input[type="radio"], variant-selects input[type="radio"]'), function (x) { return x.value === val; })[0];
        if (r && !r.checked) r.click();
      });
    }
    setTimeout(function () {
      var suite = Promise.resolve();
      if (G.clapets) suite = suite.then(function () { return choisirGpo('clapets', c.clapets === 'rog' ? 'ROG' : 'Origine'); });
      if (G.reso) suite = suite.then(function () { return choisirGpo('caractère du son', c.reso === 'rond' ? G.resoVals.rond : G.resoVals.pur); });
      var rog = c.emb.indexOf('rog:') === 0 ? EMB_ROG.filter(function (e) { return 'rog:' + e[0] === c.emb; })[0][1] : 'Sans embout';
      var mp = c.emb.indexOf('mp:') === 0 ? EMB_MP.filter(function (e) { return 'mp:' + e[0] === c.emb; })[0][1] : 'Sans embout';
      if (G.rog) suite = suite.then(function () { return choisirGpo('embouts rog', rog); });
      if (G.mp) suite = suite.then(function () { return choisirGpo('embouts m perf', mp); });
      if (c.mat === 'ti') suite = suite.then(function () { return choisirGpo('couleur titane', COUL.filter(function (k) { return k[0] === c.couleur; })[0][1], true); });
      suite.then(function () {
        var cible = document.querySelector('variant-selects') || document.querySelector('.gpo-app');
        var bloc = cible && (cible.closest('.product__info-container') ? cible : cible);
        if (bloc) {
          var y = bloc.getBoundingClientRect().top + window.pageYOffset - 110;
          window.scrollTo({ top: y, behavior: REDUIT ? 'auto' : 'smooth' });
        }
        notifier(t('applique') + ' · ' + argent(prix(c)));
      });
    }, 480);
  }
  function notifier(txt) {
    var n = document.createElement('div');
    n.className = 'rogc-toast';
    n.setAttribute('role', 'status');
    n.innerHTML = I_OK + '<span>' + esc(txt) + '</span>';
    document.body.appendChild(n);
    setTimeout(function () { n.remove(); }, 3300);
  }

  /* ---------- Démarrage ---------- */
  function charger(url) { return fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  charger(D.i18n).catch(function () { return charger(D.i18nFr); }).then(function (j) {
    T = j || {};
    Array.prototype.forEach.call(entree.querySelectorAll('[data-rogc-t]'), function (el) { el.textContent = t(el.getAttribute('data-rogc-t')); });
    if (!autorise()) return;
    entree.hidden = false;
    document.getElementById('rogc-ouvrir').addEventListener('click', ouvrir);
  }).catch(function () {});
})();
